import React from 'react';

import styled from 'styled-components';
import { DataElementContext } from '@/page-components/common/DataElementContext';

import { useTranslation } from 'react-i18next';

type RegisterProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: {
    dsType: string;
  };
};

type ModuleStateProps = {
  currentStep: string;
};

const defaultProps = {
  className: '',
  styleText: '',
  properties: {
    dsType: '',
  },
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const RegisterStepper = (componentProps: RegisterProps) => {
  const { t } = useTranslation();

  /************************   TODO  ****************/

  const listener = (e: any) => {
    console.log(e); // TODO: change step
  };
  const refListener = listener;

  React.useEffect(() => {
    window.addEventListener('storage', refListener, false);
    return () => {
      window.removeEventListener('storage', refListener);
    };
  }, []);

  const tmpProps = { ...defaultProps, ...componentProps };
  delete tmpProps.children;
  const props = JSON.parse(JSON.stringify(tmpProps));
  const { children } = componentProps;

  const initialState = {
    currentStep: 'step1',
  };

  const [state, setState] = React.useState<ModuleStateProps>(initialState);

  const contextValue = {
    ...state,
  };

  return (
    <ModuleElementDiv className={props.className ?? ''} $styleText={props.styleText}>
      <DataElementContext.Provider value={contextValue}>{children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default RegisterStepper;
